import { Text } from "@meditect/medibase-components";

export const SalesCannotCreateNewVersionOfSaleWithPaidBillsError = () => {
  return <Text>Cette vente contient des paiements inclus dans des factures clôturées</Text>;
};
